export default __webpack_public_path__ + "static/media/Suyane_Mike_HickDuarte_32990.1beb7e90.jpg";